import { md5 } from 'js-md5';


export class Md5Service {
  public static async compute(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      fileReader.onerror = function(): void {
        reject('MD5 computation failed - error reading the file');
      };

      fileReader.onload = function(e: any): void {
        const sum = md5(e.target.result);
        resolve(sum);
      };

      fileReader.readAsArrayBuffer(file);
    });
  }
}
